<template>
    <div class="login-form">
        <img src="/cdn/images/loading.gif" v-if="loading" class="loading-gif">
        <div class="header">
            <b>{{ heading }}</b>
            <p v-if="!remove_subtext">Login below to checkout with an existing account</p>
        </div>
        <div class="body">
            <form>
                <div class="field">
                    <label for="email">Email Address</label>
                    <input type="email" name="email" id="email" v-model="form.email" />
                </div>
                <div class="field">
                    <label for="password">Password</label>
                    <input type="password" name="password" id="password" v-model="form.password" />
                </div>
                <div class="buttons">
                    <button @click.prevent="submit()" v-bind:disabled="loading">{{ login_text() }}</button>
                    <div class="forgot">
                        <a v-bind:href="netsuite_app_url + 'checkout.ssp?is=login&login=T&fragment=login-register#/forgot-password'">Forgot Password?</a>
                    </div>
                </div>
                <label class="error" v-show="message !== ''">
                    {{ message }}
                </label>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    name: "login-form",
    data() {
        return {
            form: {
                email: '',
                password: ''
            },
            loading: false,
            message: ''
        };
    },
    props: {
        netsuite_url: {
            type: String,
        },
        netsuite_app_url: {
            type: String,
        },
        heading: {
            section: String,
            default: "RETURNING USER"
        },
        remove_subtext: {
            section: Boolean,
            default: false
        },
    },
    methods: {
        login_text() {
            return this.loading ? 'Logging in' : 'Log in';
        },
        async submit() {
            this.loading = true;
            let response = await axios.post(this.netsuite_app_url + `services/Account.Login.Service.ss`, this.form, { withCredentials: true });
            if (response.data.errorStatusCode && response.data.errorStatusCode == 400) {
                this.message = 'Incorrect email or password.';
                this.loading = false;
            } else {
                try {
                    // Update dealer session
                    axios.get(`/${this.getCulture}/api/isDealer/enable`);
                    axios.post(`/${this.getCulture}/api/dealer-check`);
                    setTimeout(function() {window.location = '/'; });
                } catch (error) {
                    console.error(error);
                    setTimeout(function(){ window.location = '/'; });
                }
            }
        }
    },
    computed: {
        getCulture() {
            return window.culture;
        }
    }
};
</script>
